import { getRootVar } from '@immosky/shared';
import { colorOrange } from '@immosky/styles';
import { MapShapeRenderer, Region, RegionID } from '@immosky/types';

export class MapCircleRenderer implements MapShapeRenderer {
  private readonly activeCircles = new Map<RegionID, google.maps.Circle>();
  private regions: Region[] = [];
  private radius = 2000;
  private isRadiusFilterActive = false;

  constructor(private map: google.maps.Map) {}

  update(regions: Region[], radius = 2000, isRadiusFilterActive = false) {
    this.regions = regions;
    this.radius = radius;
    this.isRadiusFilterActive = isRadiusFilterActive;
    this.createCircles();
  }

  clear() {
    for (const [key, circle] of this.activeCircles) {
      circle.setMap(null);
    }
    this.activeCircles.clear();
  }

  getBounds(): google.maps.LatLng[] {
    const bounds: google.maps.LatLng[] = [];
    for (const [key, circle] of this.activeCircles) {
      const circleBounds = circle.getBounds();
      if (circleBounds) {
        bounds.push(circleBounds.getNorthEast());
        bounds.push(circleBounds.getSouthWest());
      }
    }
    return bounds;
  }

  private createCircles() {
    for (const region of this.regions) {
      if (
        (this.regions.length === 1 && this.isRadiusFilterActive) ||
        region.geometry.type === 'Point'
      ) {
        this.createCircle(region);
      }
    }
  }

  private createCircle(region: Region) {
    if (this.activeCircles.has(region.id)) {
      return;
    }

    const circleCenter = region.centroid;

    const circle = new google.maps.Circle({
      center: circleCenter,
      radius: this.radius, // in meters
      strokeColor: getRootVar('--map-marker-color', colorOrange),
      strokeWeight: 2,
      strokeOpacity: 0.6,
      fillColor: getRootVar('--map-marker-color', colorOrange),
      fillOpacity: 0.1,
      clickable: false,
      map: this.map,
    });

    this.activeCircles.set(region.id, circle);
  }
}
